<!-- =========================================================================================
    File Name: TechnicAddNew.vue
    Description: Add new technic component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="salesAddNew">
    <vs-prompt
      name="serviskaydi"
      vs-title="Yeni Satış Teklifi"
      vs-accept-text="Kaydet"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="cancel"
      @vs-accept="submitRegistiration"
      @vs-close="cancel"
      :vs-is-valid="validateForm"
      :vs-active.sync="addNewRegister"
    >
      <div>
        <VuePerfectScrollbar class="scroll-area" :settings="settings">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/4 text-right">
              <vs-button color="warning" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
              <feather-icon v-if="1 == 2" icon="RefreshCwIcon" title="Yenile" svgClasses="h-5 mr-5 hover:text-danger cursor-pointer" @click="submitRegistiration()" />
            </div>
            <div class="vx-col md:w-1/2 flex small-icon">
              <vs-input icon-pack="feather" icon="icon-user" class="w-full" placeholder="Müşteri Ara" v-model="searchQuery" @keyup="delayedSearch" />
              <vs-button type="border" class="ml-5" @click="search">Ara</vs-button>
            </div>
            <div class="vx-col md:w-1/4"></div>
          </div>
          <add-new-customer :addnew="addNewCust" :withAdditionalData="true" v-if="addNewCust" @hideAddNewRegister="hideAddNewCust"></add-new-customer>
          <div class="vx-row mr-2" id="tblSearchResultsContainer">
            <div class="vx-col w-full">
              <vs-table noDataText="Tabloda Veri Yok" :data="customerSearch">
                <template slot="thead">
                  <vs-th hidden>id</vs-th>
                  <vs-th class="w-1/3">Müşteri</vs-th>
                  <vs-th class="w-1/6">Telefon</vs-th>
                  <vs-th class="w-1/3">Adres</vs-th>
                  <vs-th class="w-1/6">Seç</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="data[i].userId" v-for="(tr, i) in data" class="pt-0 pb-1" :state="tr.span ? 'danger' : ''" :title="tr.span ? 'Kendisiyle iletişim kurulmasını istemiyor!' : ''">
                    <vs-td hidden :data="data[i].userId" class="pt-0 pb-1">{{ data[i].userId }}</vs-td>

                    <vs-td :data="tr.firstName + ' ' + (tr.lastName || '')" class="pt-0 pb-1">{{ tr.firstName + " " + (tr.lastName || "") }}<b v-if="tr.span"> Kendisiyle iletişim kurulmasını istemiyor</b></vs-td>

                    <vs-td :data="data[i].phone" class="pt-0 pb-1">
                      {{ data[i].phone }}
                    </vs-td>

                    <vs-td :data="data[i].address" class="pt-0 pb-1">
                      {{ data[i].address }}
                    </vs-td>

                    <td class="flex">
                      <vs-radio icon="CheckSquareIcon" class="ml-2" v-model="selectedCustomerRadio" :vs-value="i" @change="selectItem(i)" />

                      <a :id="'lnkCustomer_' + data[i].customerId" style="display: none;" :href="'/contactsEdit/' + data[i].customerId" target="_blank"></a>
                      <feather-icon
                        v-if="!data[i].isReadyForInvoice && !data[i].isOnlineCustomer"
                        icon="AlertOctagonIcon"
                        class="ml-2 kucukbuton"
                        svgClasses="w-8 h-8 hover:text-primary danger"
                        @click.stop="openCustomer(data[i].customerId)"
                        :title="data[i].error"
                      />
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
          <!-- 1.row -->
          <div class="vx-row mt-3 mr-2">
            <div class="vx-col w-1/2">
              <vs-input size="small" disabled name="customerName" class="w-full mb-2 mt-0" placeholder="Adı Soyadı" v-validate="'required'" v-model="formFeatures.customerName" :color="validateForm ? 'success' : 'danger'" />
              <span v-show="errors.has('customerName')" class="errorfonts">{{ errors.first("customerName") }}</span>
            </div>
            <div class="vx-col w-1/2">
              <vs-input size="small" disabled name="customerPhone" class="w-full mb-2 mt-0" :placeholder="!formFeatures.customerId ? 'Telefonu' : ''" v-model="formFeatures.customerPhone" :color="validateForm ? 'success' : 'danger'" />
            </div>
          </div>
          <!-- 2.row -->
          <div class="vx-row mr-2">
            <div class="vx-col w-1/2">
              <label class="text-sm">Fatura Adresi</label>
              <vs-textarea disabled name="customerBillAddress" class="w-full mb-2 mt-0" v-model="formFeatures.customerBillAddress" :color="validateForm ? 'success' : 'danger'" />
            </div>
            <div class="vx-col w-1/2">
              <label class="text-sm">Teslimat Adresi</label>
              <vs-textarea v-validate="'required'" name="customerDeliverAddress" class="w-full mb-2 mt-0" v-model="formFeatures.customerDeliverAddress" :color="validateForm ? 'success' : 'danger'" />
              <span v-show="errors.has('customerDeliverAddress')" class="errorfonts">{{ errors.first("customerDeliverAddress") }}</span>
            </div>
          </div>
          <!-- 3.row -->

          <div class="vx-row mr-2">
            <div class="vx-col w-1/2">
              <label class="text-sm">Düzenleme Tarihi</label>

              <input class="w-full mb-2 mt-0" type="datetime-local" v-model="formFeatures.arrangementDate" name="arrangementDate" @change="isValid($event, '', 'red')" />
            </div>
            <div class="vx-col w-1/2">
              <label class="text-sm">Geçerlilik Tarihi</label>

              <input class="w-full mb-2 mt-0" type="datetime-local" v-model="formFeatures.validityDate" name="validityDate" @change="isValid($event, '', 'red')" />
            </div>
          </div>
          <!-- 4.row -->

          <div class="vx-row mr-2">
            <div class="vx-col w-1/2">
              <v-select
                v-validate="'required'"
                v-model="formFeatures.selectedPaymentType"
                class="w-full select-large mb-2 style-chooser"
                placeholder="Ödeme türü seçin"
                :options="selectedPaymentTypeOptions"
                name="selectedPaymentType"
                :reduce="(selectedPaymentTypeOptions) => selectedPaymentTypeOptions.id"
                label="value"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span v-show="errors.has('selectedPaymentType')" class="errorfonts">{{ errors.first("selectedPaymentType") }}</span>
            </div>
            <div class="vx-col w-1/2">
              <v-select
                v-validate="'required'"
                v-model="formFeatures.saleOrderType"
                class="w-full select-large mb-2 style-chooser"
                name="saleOrderTypesOptions"
                placeholder="Satış Türü seçin"
                :options="saleOrderTypesOptions"
                :reduce="(saleOrderTypesOptions) => saleOrderTypesOptions.id"
                label="value"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span v-show="errors.has('saleOrderTypesOptions')" class="errorfonts">{{ errors.first("saleOrderTypesOptions") }}</span>
            </div>
          </div>
          <!-- 5.row -->

          <div class="vx-row mr-2">
            <div class="vx-col w-1/2">
              <v-select
                v-validate="'required'"
                name="saleDeliveryTypeOptions"
                class="w-full select-large mb-2 style-chooser"
                placeholder="Teslimat türü Seçin"
                v-model="formFeatures.saleDeliveryType"
                :options="saleDeliveryTypeOptions"
                :reduce="(saleDeliveryTypeOptions) => saleDeliveryTypeOptions.id"
                label="value"
              >
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span v-show="errors.has('saleDeliveryTypeOptions')" class="errorfonts">{{ errors.first("saleDeliveryTypeOptions") }}</span>
            </div>
            <div class="vx-col md:w-1/2">
              <div class="vx-row">
                <div class="vx-col md:w-1/3">
                  <span class="mr-2">{{ formFeatures.taxIncluded ? "KDV Dahil" : "KDV Hariç" }}</span>
                  <vs-switch size="small" v-model="formFeatures.taxIncluded" @change="calculate" />
                </div>
                <div class="vx-col md:w-1/3">
                  <span style>
                    Tam Fatura
                  </span>

                  <vs-switch v-model="formFeatures.isFullInvoice" />
                </div>
                <div class="vx-col md:w-1/3">
                  <v-select
                    v-validate="'required'"
                    name="selectedMoneyCurrencyOptions"
                    class="w-full select-large mb-2 style-chooser"
                    placeholder="Para birimi seçin"
                    v-model="formFeatures.selectedMoneyCurrency"
                    :options="selectedMoneyCurrencyOptions"
                    :clearable="false"
                    label="value"
                  >
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                  <span v-show="errors.has('selectedMoneyCurrencyOptions')" class="errorfonts">{{ errors.first("selectedMoneyCurrencyOptions") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mr-2">
            <div class="vx-col w-full">
              <label class="text-sm">Sipariş Detayları</label>
              <vs-textarea name="orderNote" class="w-full mb-2 mt-0" v-model="formFeatures.orderNote" :color="validateForm ? 'success' : 'danger'" />
            </div>
          </div>
          <!-- satış işlemlerideki listelenen Ürünler -->
          <ag-grid-table :openProducts="openProductPopup" v-model="agSelectedProducts" v-if="openProductPopup" @hideProducts="hideProductPopup"></ag-grid-table>

          <div class="mt-1 mr-5">
            <vs-table noDataText="Tabloda Veri Yok" :data="selectedProducts">
              <template slot="header">
                <h5>Ürünler</h5>
                <vs-button size="small" type="filled" @click="selectProducts">Ürünler</vs-button>
              </template>
              <template slot="thead">
                <vs-th>Ürün</vs-th>
                <vs-th>Birim Fiyat</vs-th>
                <vs-th>Adet</vs-th>
                <vs-th>Satış Fiyatı</vs-th>
                <vs-th>İndirim Yüzdesi</vs-th>
                <vs-th v-if="formFeatures.taxIncluded">KDV</vs-th>
                <vs-th>Toplam</vs-th>
                <vs-th>İşlem</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td hidden :data="data[indextr].productId">
                    {{ data[indextr].productId }}
                  </vs-td>
                  <!-- ürün adı-->
                  <vs-td :data="data[indextr].productName">
                    {{ data[indextr].productName }}
                  </vs-td>
                  <!-- fiyatı -->
                  <vs-td :data="data[indextr].price"> {{ data[indextr].price.toFixed(2) }}{{ " " + formFeatures.selectedMoneyCurrency.logo }} </vs-td>
                  <!-- adeti-->
                  <vs-td :data="data[indextr].quantity">{{ data[indextr].quantity + " Adet" }}</vs-td>
                  <!--satıs fıyatı -->
                  <vs-td :data="data[indextr].sellPrice"> {{ data[indextr].sellPrice.toFixed(2) }}{{ " " + formFeatures.selectedMoneyCurrency.logo }} </vs-td>
                  <!-- ındırm yuzdesı -->
                  <vs-td :style="profit(data[indextr]) < 0 ? 'color:red;font-weight:bolder;' : ''">{{ beautifyProfit(data[indextr]) }}</vs-td>
                  <!-- vergı oranı-->
                  <vs-td v-if="formFeatures.taxIncluded">%20</vs-td>
                  <!-- toplam vergili -->
                  <vs-td v-if="formFeatures.taxIncluded" :data="data[indextr].quantity"> {{ (tr.quantity * (tr.sellPrice + tr.sellPrice * kdvRate)).toFixed(2) }}{{ " " + formFeatures.selectedMoneyCurrency.logo }} </vs-td>

                  <!--  toplam vergisiz-->
                  <vs-td v-if="!formFeatures.taxIncluded" :data="data[indextr].quantity"> {{ (data[indextr].quantity * data[indextr].sellPrice).toFixed(2) }}{{ " " + formFeatures.selectedMoneyCurrency.logo }} </vs-td>
                  <!-- işlem -->
                  <vs-td>
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="deleteRow(data[indextr])"></vs-button>
                  </vs-td>
                </vs-tr>

                <vs-tr v-if="data.length != 0">
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                  <vs-td>
                    <hr />
                  </vs-td>
                </vs-tr>

                <vs-tr v-if="data.length != 0">
                  <vs-th>Genel Toplam</vs-th>
                  <vs-th colspan="3"></vs-th>
                  <vs-th>
                    {{ beautifyDiscount }}
                  </vs-th>
                  <vs-th v-if="formFeatures.taxIncluded"></vs-th>
                  <vs-th> {{ grandTotal.priceDiscounted.toFixed(2) }}{{ " " + formFeatures.selectedMoneyCurrency.logo }} </vs-th>
                  <vs-th colspan="1"></vs-th>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import agGridTable from "./addComponents/agGridTable.vue";
import { repository } from "@/_services/repository.js";
import addNewCustomer from "../contacts/addNewPrompt.vue";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

const dict = {
  custom: {
    selectedPaymentType: {
      required: "Ödeme türü seçmediniz!",
    },
    saleDeliveryTypeOptions: {
      required: "Teslimat türü seçmediniz!",
    },
    customerDeliverAddress: {
      required: "Teslimat adresigiriniz!",
    },
    saleOrderTypesOptions: {
      required: "Satış türü seçmediniz!",
    },
    customerName: {
      required: "Müşteri seçmediniz!",
    },
    arrangementDate: {
      required: "zorunlu!",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    vSelect,
    agGridTable,
    addNewCustomer,
    VuePerfectScrollbar,
  },
  props: {
    addnew: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      agSelectProducts: [],
      addNewCust: false,

      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      openProductPopup: false,
      kdvRate: 0.20,
      selectedMoneyCurrencyOptions: [],
      saleDeliveryTypeOptions: [],
      selectedPaymentTypeOptions: [],
      saleOrderTypesOptions: [],
      serviceStatus: [
        { text: "KDV'li", value: true },
        { text: "KDV'siz", value: false },
      ],
      //table in mid of popup
      selectedProducts: [],
      searchQuery: "",
      selectedCustomer: {},
      selectedCustomerRadio: {}.empty,
      customerSearch: [],
      delayedSearchTimer: null,

      grandTotal: {
        sumUnitPrice: 0,
        sumSalePrice: 0,
        sumquantity: 0,
        price: 0,
        discountPercent: 0,
      },

      formFeatures: {
        customerId: 0,
        customerName: "",
        customerPhone: "",
        customerBillAddress: "",
        customerDeliverAddress: "",
        arrangementDate: "",
        validityDate: "",
        selectedPaymentType: "",
        saleOrderType: "",
        saleDeliveryType: "",
        isFullInvoice: 0,
        selectedMoneyCurrency: {
          id: 3,
          value: "TRY",
          logo: "₺",
          name: "Türk Lirası",
        },
        taxIncluded: true,
        orderNote: "",

        products: [],
      },
      previousTaxState: Boolean,
      withInvoice: true,
    };
  },
  computed: {
    getDate() {
      let d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().substr(0, 16);
    },
    beautifyDiscount() {
      if (this.grandTotal.discountPercent < 0.01 && this.grandTotal.discountPercent > -0.01) {
        if (this.grandTotal.discountPercent < 0.000000001 && this.grandTotal.discountPercent > -0.000000001) return "-";
        else return "- / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + this.formFeatures.selectedMoneyCurrency.logo;
      }
      return "% " + (this.grandTotal.discountPercent * 100).toFixed(2) + " / " + (this.grandTotal.priceDiscounted - this.grandTotal.sumUnitPrice).toFixed(2) + " " + this.formFeatures.selectedMoneyCurrency.logo;
    },
    addNewRegister: {
      get() {
        return this.addnew;
      },
      set() {},
    },
    validateForm() {
      return (
        new Date(this.formFeatures.arrangementDate) < new Date(this.formFeatures.validityDate) &&
        !isNaN(parseInt(this.formFeatures.saleDeliveryType)) &&
        !isNaN(parseInt(this.formFeatures.selectedPaymentType)) &&
        !isNaN(parseInt(this.formFeatures.saleOrderType)) &&
        this.selectedCustomer &&
        this.selectedCustomer.address &&
        this.selectedCustomer.address.length > 0 &&
        Array.isArray(this.formFeatures.products) &&
        this.formFeatures.products.length > 0
      );
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideAddNewRegister", false);
      }
    });
  },
  methods: {
    SetSaleRule: async function ($event) {
      console.log($event);
    },

    isValid(event, success, fail) {
      if (event instanceof Event) {
        if (event["target"] && event.target instanceof HTMLInputElement) {
          let e = document.getElementsByName(event.target.name);
          if (this.isDateTime(event)) {
            if (e && e[0]) {
              e[0].style["color"] = success;
            }
          } else {
            if (e && e[0]) e[0].style["color"] = fail;
          }
        }
      }
      return false;
    },
    isDateTime(d) {
      if (d instanceof Date) {
        return !isNaN(d);
      }
      if (typeof d === "string") {
        return this.isDateTime(new Date(d));
      }
      if (d instanceof Event) {
        if (d["target"] && d.target instanceof HTMLInputElement) return this.isDateTime(new Date(d.target.value));
      }
    },
    openCustomer(id) {
      console.warn("id", id, "lnk", document.getElementById("lnkCustomer_" + id));
      document.getElementById("lnkCustomer_" + id).click();
    },
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
    selectItem(i) {
      if (!this.customerSearch[i].isReadyForInvoice) {
        if (!this.customerSearch[i].isOnlineCustomer) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: this.customerSearch[i].error,
          });
          return;
        }
      }
      this.selectedCustomer = JSON.parse(JSON.stringify(this.customerSearch[i]));
      if (this.selectedCustomer.lastName != null) this.formFeatures.customerName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
      else {
        this.formFeatures.customerName = this.selectedCustomer.firstName;
      }
      this.formFeatures.customerId = this.selectedCustomer.customerId;
      this.formFeatures.customerPhone = this.selectedCustomer.phone;
      this.formFeatures.customerBillAddress = this.selectedCustomer.billingAddress;
      this.formFeatures.customerDeliverAddress = this.selectedCustomer.address;
    },
    search: async function () {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);
      for (let i = 0; i < this.customerSearch.length; i++) {
        let c = this.customerSearch[i];
        let span = c.firstName.indexOf("</span>");
        if (span > 0) {
          c.firstName = c.firstName.substr(span + 7).trim();
          c.span = true;
        }
      }
      return this.customerSearch;
    },
    profit: function (e) {
      let a = (e.sellPrice - e.price) / e.price;
      if (a < 0.01 && a > -0.01) return "-";
      a = a * 100;
      return a;
    },
    beautifyProfit: function (e) {
      let r = this.profit(e);
      if (typeof r == "number") {
        return "%" + r.toFixed(2);
      }
      return "-";
    },
    calculate: function () {
      this.grandTotal.sumUnitPrice = 0;
      this.grandTotal.sumquantity = 0;
      this.grandTotal.priceDiscounted = 0;
      this.grandTotal.discountPercent = 0;
      let sumSalePrice = 0;
      //kdv yüzdesi
      let a = 0;

      if (this.selectedProducts.length > 0) {
        for (let i = 0; i < this.selectedProducts.length; i++) {
          //toplam birim fiyat
          this.grandTotal.sumUnitPrice = this.selectedProducts[i].price * this.selectedProducts[i].quantity + this.grandTotal.sumUnitPrice;
          //toplam adet
          this.grandTotal.sumquantity = this.grandTotal.sumquantity + parseInt(this.selectedProducts[i].quantity);

          sumSalePrice = this.selectedProducts[i].sellPrice * this.selectedProducts[i].quantity + sumSalePrice;

          if (this.formFeatures.taxIncluded) a = this.kdvRate;
          else a = 0;

          //toplam indirmli fiyat
          this.grandTotal.priceDiscounted = (this.selectedProducts[i].sellPrice + this.selectedProducts[i].sellPrice * a) * parseInt(this.selectedProducts[i].quantity) + this.grandTotal.priceDiscounted;

          //toplam indirim yüzdesi
          this.grandTotal.discountPercent = (sumSalePrice - this.grandTotal.sumUnitPrice) / this.grandTotal.sumUnitPrice;
        }
      }
    },
    hideProductPopup(r, data) {
      this.openProductPopup = false;

      if (r == 0) return;

      this.selectedProducts = [];
      this.selectedProducts = [].concat(data);

      for (let i = 0; i < this.selectedProducts.length; i++) {
        let price = parseFloat(this.selectedProducts[i].sellPrice);
        if (isNaN(price)) return;

        //measure price without discounted
        console.log("1",price)
        if (this.formFeatures.taxIncluded) price = price * 0.8333333333333333333333333333333333333333333333333333333333333333;
        console.log("2",price)
        this.selectedProducts[i].priceDiscounted = price;
        this.selectedProducts[i].priceWithTaxes = price * 1.20;
        console.log("3",price);
        console.log("ss",this.selectedProducts[i].priceWithTaxes)
        this.selectedProducts[i].sellPrice = price;
        
      }
      if (this.selectedProducts.length > 0) {
        this.calculate();
        this.formFeatures.products.splice(0, this.formFeatures.products.length);
        for (let x = 0; x < this.selectedProducts.length; x++) {
          this.formFeatures.products.push({
            productId: this.selectedProducts[x].productId,
            productType: 1,
            productAmount: this.selectedProducts[x].quantity,
            discount: 0,
            discountPercent: 0,
            price: this.selectedProducts[x].sellPrice,
            priceId: 3,
            priceDiscounted: this.selectedProducts[x].sellPrice,
            lineType: 1,
            wareHouseId: this.selectedProducts[x].wareHouseId,
            id: -1,
          });
        }
      }
      sessionStorage.setItem("selectedProductsSessionStorage", JSON.stringify(this.selectedProducts));
    },

    selectProducts() {
      this.agSelectProducts = [];
      this.agSelectedProducts = [].concat(this.selectedProducts);
      if (this.agSelectedProducts && this.agSelectedProducts.length > 0) this.agSelectedProducts[0].taxIncluded = this.formFeatures.taxIncluded;
      this.openProductPopup = true;
    },

    isAdmin() {
      return this.$store.state.userData.role === "Admin";
    },

    //selected items on ag-grid will delete
    deleteRow: function (d) {
      this.selectedProducts = this.selectedProducts.filter((val) => d.productId != val.productId || d.wareHouseId != val.wareHouseId);
      sessionStorage.setItem("selectedProductsSessionStorage", JSON.stringify(this.selectedProducts));
      this.calculate();
    },
    cancel() {
      sessionStorage.setItem("unfinishedSalesForm", JSON.stringify(this.formFeatures));
      sessionStorage.setItem("selectedProductsSessionStorage", JSON.stringify(this.selectedProducts));
      this.$emit("hideAddNewRegister");
    },
    clearFields() {
      sessionStorage.removeItem("unfinishedSalesForm");
      this.formFeatures = {};
    },
    isAllValid: async function () {
      return await this.$validator.validateAll();
    },
    submitRegistiration: async function () {
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //Bu kısım pair ürünler için belirli bir sayıda satılması için kodlanmıştır.

      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "11") != null) {
        null;
      } else {
        let pairProductList = this.selectedProducts.filter((r) =>  [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006].includes(r.productId));

        let sumOfQuantity = pairProductList.reduce((acc, ele) => {
          return acc + ele.quantity;
        }, 0);

        if (sumOfQuantity > 0 && sumOfQuantity < 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubunda Yetersiz Sayı Hatası",
            text: "ProductId si [1638, 1917, 2937, 1347, 1348, 1349, 1350, 1351, 1352, 1354, 1355, 1357, 3156, 3006] olan ürünler için en az toplam 3 adet olmalıdır.",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }
      //Bu kısım pair ürünler için belirli bir sayıda satılması için kodlanmıştır.
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //Bu kısım Sale Rule içindir.

      if (this.$store.state.userData.authorizationList.find((f) => f.authorizationId == "19") != null) {
        null;
      } else {
        let fullInvoiceProductList = this.selectedProducts.filter((r) =>
          [2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2965, 2966, 1078, 1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161].includes(r.productId)
        );

        let sumOfFullInvoiceQuantity = fullInvoiceProductList.reduce((acc, ele) => {
          return acc + ele.quantity;
        }, 0);

        //Kural 1
        if (this.formFeatures.selectedPaymentType == 7 && (this.formFeatures.selectedMoneyCurrency.id != 3 || this.formFeatures.isFullInvoice == false)) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ödeme türü  TL ve Tam Fatura olmalıdır",
            text: "Ödeme türü kurumsal olan işlemler için para türü TL ve Tam Fatura olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 3
        if (sumOfFullInvoiceQuantity > 0 && this.formFeatures.isFullInvoice == false) {
          await this.$swal.fire({
            icon: "warning",
            title: "Ürün Grubu Tam Fatura Hatası",
            text: `ProductId si  2334, 2789, 1941, 1933, 2738, 2739, 2746, 2743, 2744, 2740, 2849, 2847, 2741, 2742, 2854, 2853, 2965, 2966, 1078, 
                    1507, 2885, 2960, 2893, 2018, 2107, 2843, 3157, 3158, 3159, 3160, 3161 olan ürünler için tam fatura seçili olmalıdır.`,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }

        //Kural 3
        if (this.formFeatures.selectedPaymentType == 4 && this.formFeatures.selectedMoneyCurrency.id == 3) {
          await this.$swal.fire({
            icon: "warning",
            title: "Hata",
            text: "Ödeme türü açık hesap olan işlemler için para türü $ veya € olmalıdır",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }
      //Bu kısım Sale Rule içindir.
      ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (!this.formFeatures.customerId || this.formFeatures.customerId <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen müşteri seçtiğinizden emin olunuz!",
        });
        return;
      }
      if (this.selectedCustomer.isOnlineCustomer && this.formFeatures.saleOrderType != 2) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "E-Ticaret müşterisi için satış türü sadece Internet seçilebilir!",
        });
        return;
      }
      if (this.formFeatures.products.length <= 0) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Lütfen ürün seçtiğinizden emin olunuz!",
        });
        return;
      }

      for (let i = 0; i < this.selectedProducts.length; i++) {
        //id boşsa id alanı oluştur
        if (!this.formFeatures.products[i].id) this.formFeatures.products[i].id = -1;
        //wareHouseId alanı boşsa oluştur
        if (!this.formFeatures.products[i].wareHouseId) this.formFeatures.products[i].wareHouseId = -1;

        //price alanı boşsa sellPrice dan al
        if (!this.formFeatures.products[i].price || this.formFeatures.products[i].price <= 0) this.formFeatures.products[i].price = this.selectedProducts[i].sellPrice;

        //priceDiscounted=sellprice
        this.formFeatures.products[i].priceDiscounted = this.selectedProducts[i].sellPrice;

        //productamount=quantity
        this.formFeatures.products[i].productAmount = this.selectedProducts[i].quantity;
      }

      let postModel = {
        customerId: this.formFeatures.customerId,
        orderNote: this.formFeatures.orderNote,
        saleOrderType: this.formFeatures.saleOrderType,
        createdDate: this.formFeatures.arrangementDate,
        validUntil: this.formFeatures.validityDate,
        taxIncluded: this.formFeatures.taxIncluded,
        currencyType: this.formFeatures.selectedMoneyCurrency.id,
        paymentType: this.formFeatures.selectedPaymentType,
        deliveryType: this.formFeatures.saleDeliveryType,
        deliveryAddress: this.formFeatures.customerDeliverAddress,
        OrderLines: this.formFeatures.products,
        price: this.grandTotal.sumUnitPrice,
        priceDiscounted: this.grandTotal.priceDiscounted,
        discount: this.grandTotal.priceDiscounted,
        discountPercent: this.grandTotal.discountPercent,
        isFullInvoice: this.formFeatures.isFullInvoice,
      };

      let control = false;
      control = this.isAllValid();

      if (control) {
        let r = await repository.postEntity("Sale/createOrder", postModel);
        if (r.isSuccessful) {
          this.$vs.notify({
            color: "success",
            icon: "done",
            title: "Tamamlandı",
            text: "Ekleme işlemi başarılı!",
          });

          this.$emit("hideAddNewRegister");
          this.clearFields();
        } else if (r.hasExceptionError) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: r.exceptionMessage,
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
          });
        }
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Eksik alanlar var!",
        });
      }
    },
    getPaymentTypes: async function () {
      let a = await repository.getAll("Accounting/getPaymentTypes");
      if (a && a.list) this.selectedPaymentTypeOptions = a.list;
      else {
        this.$vs.notify({
          title: "Ödeme Tipleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getCurrencies: async function () {
      let a = await repository.getAll("General/getCurrencies");
      if (a && a.list) this.selectedMoneyCurrencyOptions = a.list;
      else {
        this.$vs.notify({
          title: "Para Birimleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getOrderTypes: async function () {
      let a = await repository.getAll("Sale/getOrderTypes");
      if (a && a.list) this.saleOrderTypesOptions = a.list;
      else {
        this.$vs.notify({
          title: "Teslimat Türleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
    getSaleDeliveryType: async function () {
      let a = await repository.getAll("General/getDeliveryTypes");
      if (a && a.list) this.saleDeliveryTypeOptions = a.list;
      else {
        this.$vs.notify({
          title: "Satış Tipleri Çekilemedi",
          text: (a && a.hasExceptionError && a.exceptionMessage) || "bilinmeyen hata oluştu.",
          color: "danger",
          icon: "warning",
        });
      }
    },
  },
  created() {
    this.getSaleDeliveryType();
    this.getPaymentTypes();
    this.getCurrencies();
    this.getOrderTypes();
    this.formFeatures.arrangementDate = this.getDate;
    this.formFeatures.validityDate = new Date(new Date(this.formFeatures.arrangementDate).getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 16);
    let a = sessionStorage["unfinishedSalesForm"];
    if (repository.isJSON(a)) {
      a = JSON.parse(a);
      let b = this.formFeatures;
      let bKeys = Object.keys(b);
      let prdKeys = Object.keys(b.products);

      let control = true;

      //elimizdeki veri ile storagaden gelen karşılaşıtrılıyor
      for (let i = 0; i < bKeys.length; i++) {
        if (typeof a[bKeys[i]] == "undefined") {
          control = false;
          this.$vs.notify({
            title: "Uyarı !",
            text: "Yarım kalan kayıt işleminde veri kaybı yaşandı..",
            color: "warning",
            time: 4000,
            icon: "warning",
          });
          break;
        }
      }
      //elimizdeki verinin ürün kısmı  ile storagaden gelen karşılaşıtrılıyor
      if (control) {
        for (let i = 0; i < prdKeys.length; i++) {
          if (typeof a.products[prdKeys[i]] == "undefined") {
            control = false;
            break;
          }
        }
      }

      //elimizdeki veri tarih kısmı ile storagaden gelen karşılaşıtrılıyor tarhi kontrolu sureklı yenı oldugunu dusunmeısne sebep oluyor
      if (control) {
        for (let i = 0; i < bKeys.length; i++) {
          if (JSON.stringify(a[bKeys[i]]) != JSON.stringify(b[bKeys[i]]) && bKeys[i].toLowerCase().indexOf("date") < 0) {
            control = false;
            break;
          }
        }
      }

      if (control) return;

      let result = false;
      let xxx = () => {
        result = confirm(" Yarım kalan kayıt işlemine devam etmek ister misiniz ?");
      };
      xxx();
      if (result) {
        this.formFeatures = a;
        this.selectedProducts = JSON.parse(sessionStorage.getItem("selectedProductsSessionStorage"));
        this.calculate();
      } else {
        sessionStorage.removeItem("unfinishedSalesForm");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.vs-table--tbody-table .tr-values td {
  padding: 0px !important;
}
.vs-dialog i.vs-dialog-cancel {
  top: 5px !important;
  right: 10px !important;
}
.style-chooser .vs__dropdown-toggle {
  height: 25px !important;
}
.style-chooser .vs__selected {
  height: 15px !important;
}
.style-chooser .vs__search {
  height: 15px !important;
}

.kucukbuton {
  cursor: pointer;
}
.errorfonts {
  color: red;
}
@media screen and (max-width: 575px) {
}
</style>
